"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BaseLink = _interopRequireDefault(require("../BaseLink"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = _interopRequireDefault(require("./styles"));
var _excluded = ["variant", "size", "children", "inline", "uppercase", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var Link = props => {
  var classes = (0, _styles.default)(props);
  var {
      variant = 'default',
      size,
      children,
      inline = false,
      uppercase,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var getTextVariantClass = () => {
    switch (variant) {
      case 'wrapper':
        return [];
      case 'category-card':
        return [classes.category, classes.small];
      case 'category-post':
        return [classes.category, classes.medium];
      case 'title-card':
        return [classes.title, classes.large];
      case 'title-popular':
        return [classes.titlePopular];
      case 'title-general':
        return [classes.title, classes['x-large']];
      case 'author-card':
        return [classes.author, classes.small];
      case 'author-post':
        return [classes.author, classes.authorBold, classes.underline];
      case 'default-bold':
        return [classes.defaultBold, classes.medium];
      default:
        return [classes.default, classes.medium];
    }
  };
  var getTextSizeClass = () => {
    if (!size || variant === 'wrapper') {
      return null;
    }
    return classes[size];
  };
  return /*#__PURE__*/_react.default.createElement(_BaseLink.default, _extends({}, rest, {
    className: (0, _clsx.default)(...getTextVariantClass(), getTextSizeClass(), className, variant !== 'wrapper' && [classes.linkBase, !inline && classes.displayAsBlock], inline && classes.displayInline, uppercase && classes.uppercase)
  }), children);
};
var _default = exports.default = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(Link, _extends({}, props, {
  innerRef: ref
})));